"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var underscore_1 = require("underscore");

var ContentUtil_1 = __importDefault(require("../dashboard/internal/ContentUtil"));

var QueryUtil =
/** @class */
function () {
  function QueryUtil() {} // this code comes from visConditionsSupport:getConditionalMinMaxValue(). There is a story that will remove visConditionsSupport (CADBLOC-104)			


  QueryUtil.getMinMaxValuesFromQuery = function (heatId, visualization, dashboardAPI, content, queryService) {
    if (visualization.hasUnavailableMetadataColumns()) {
      return Promise.resolve();
    }

    var dataItemList = [];
    visualization.getSlots().getSlotList().forEach(function (slot) {
      slot.getDataItemList().forEach(function (dataItem) {
        var supported = !dataItem.getBinning() && dataItem.getId() !== '_multiMeasuresSeries';

        if (!supported) {
          return;
        }

        var slotType = slot.getDefinition().getType(); // Only add attribute DataItem and the Heating Data Item to the DataItemList

        var subType = slot.getDefinition().getSubType();
        var dataItemType = subType === 'latitude' || subType === 'longitude' ? 'attribute' : dataItem.getType();

        if (slotType === 'category' || slotType === 'any' && dataItemType === 'attribute' || heatId === dataItem.getId()) {
          dataItemList.push(dataItem);
        }
      });
    });

    var filterSpecList = this._getFilterSpecListByVisualization(visualization, dashboardAPI, content);

    filterSpecList.push.apply(filterSpecList, visualization.getLocalFilters().getFilterList());
    var dataItemColumnIds = underscore_1.uniq(dataItemList.map(function (dataItem) {
      return dataItem.getColumnId();
    }));
    filterSpecList = filterSpecList.filter(function (filter) {
      var filterColumnProjected = dataItemColumnIds.includes(filter.columnId);

      if (filterColumnProjected) {
        return filterColumnProjected;
      }

      var filterColumn = visualization.getDataSource().getMetadataColumn(filter.columnId);
      return filterColumn && filterColumn.getType() === 'attribute';
    });
    return queryService.getDataItemsMinMaxValues(visualization.getDataSource().getId(), dataItemList, [heatId], filterSpecList).then(function (queryResult) {
      var res = {
        min: undefined,
        max: undefined
      };

      if (queryResult.getRowCount()) {
        res.min = Math.floor(queryResult.getValue(0, 0).value);
        res.max = Math.ceil(queryResult.getValue(0, 1).value);
      }

      return res;
    });
  }; // this is a copy of dataQueryUtils:getFilterSpecListByVisualization() without the parameters - Bryan and Rami are ok with this for now


  QueryUtil._getFilterSpecListByVisualization = function (visualization, dashboardAPI, content) {
    var eventGroups = dashboardAPI.getFeature('EventGroups');
    var globalFilters = dashboardAPI.getFeature('GlobalFilters');
    var filterQuerySpecList = [];
    var dataSource = visualization.getDataSource();
    var type = dashboardAPI.getAppConfig('pageContainerType');
    var page = ContentUtil_1.default.getPageContent(content, type);
    var pageId = page && page.getId();

    if (dataSource) {
      filterQuerySpecList.push.apply(filterQuerySpecList, globalFilters.getFilterList({
        origin: 'filter',
        sourceId: dataSource.getId(),
        scope: pageId
      }, content.getId()));

      if (visualization.getDefinition().getProperty('reactToExternalBrushing') !== false) {
        var eventGroupId = eventGroups.getGroupId(content.getId());
        filterQuerySpecList.push.apply(filterQuerySpecList, globalFilters.getFilterList({
          origin: 'visualization',
          sourceId: dataSource.getId(),
          scope: pageId,
          eventGroupId: eventGroupId
        }, content.getId()));
      }
    } // Exclude binning filters since they are not fully supported by query service.


    return underscore_1.filter(filterQuerySpecList, function (filterSpec) {
      return !filterSpec.filterBins;
    });
  };

  return QueryUtil;
}();

exports.default = QueryUtil;
